<template>
  <div>
    <div class="main notfound">
      <small>404</small>
      <h1>Die gesuchte Seite ist uns wohl um die Ohren geflogen</h1>
      <p>Entdecke jetzt das REWE Feuerwerkssortiment</p>
      <router-link :to="{ path: '/' }" class="button-primary"
        >Zur Startseite</router-link
      >
    </div>
    <FooterComponent :noLegal="true" />
  </div>
</template>

<script>
import FooterComponent from "../components/Footer";
export default {
  name: "not-found",
  components: {
    FooterComponent
  }
};
</script>
